import {
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
} from '../../../../Constants/actionTypes';

import { deleteUserApi } from '../../../../Constants/apiService';

export const deleteUserRequest = () => ({ type: DELETE_USER_REQUEST });
export const deleteUserSuccess = (data) => ({ type: DELETE_USER_SUCCESS, payload: data });
export const deleteUserFailure = (error) => ({ type: DELETE_USER_FAILURE, payload: error });

export const deleteUserAct = (payload) => {
  return async (dispatch, getState) => {
    dispatch(deleteUserRequest());

    const accessToken = getState()?.auth?.accessToken;

    try {
      const data = await deleteUserApi(payload, accessToken);
      dispatch(deleteUserSuccess(data));
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently down. Please try again later.'
          : error?.message || 'Something went wrong';

      dispatch(deleteUserFailure(errorMessage));
      return null;
    }
  };
};
